import { type ReactNode } from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";
import { useAuth } from "@/hooks/useAuth";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-bg">
        <div className="size-8 rounded-full border-2 border-brand border-t-transparent animate-spin" />
      </div>
    );
  }

  // El AuthenticatedRoute en App.tsx maneja el redirect; este layout asume usuario presente.
  if (!user) {
    return <main className="min-h-screen bg-bg">{children}</main>;
  }

  return (
    <div className="min-h-screen bg-bg flex">
      <Sidebar user={user} />
      <div className="flex-1 flex flex-col min-w-0">
        <Header user={user} />
        <main className="flex-1 container py-6 md:py-10 pb-24 md:pb-10">{children}</main>
        <BottomNav user={user} />
      </div>
    </div>
  );
}
